import moment from "moment-timezone";
const logout = (state) => {
  state.user_id = "";
  state.me = null;
  state.integrations = [];
  state.organization = null;
  state.requests = [];
  state.invitations = [];
  state.scheduling = {
    settings: {},
    availability: [],
    events: [],
    embeds: [],
    pendings: [],
    polls: [],
  };
};

const setUserID = (state, payload) => {
  state.user_id = window.atob(payload);
};

const getMeInfo = (state, payload) => {
  state.me = payload.me;
  state.user_id = payload.user_id;
};

const updateMeInfo = (state, payload) => {
  for (var key in payload) {
    state.me[key] = payload[key];
  }
};

const schedulingSettings = (state, payload) => {
  var data = payload.data;
  if (payload.action == "getSettings") {
    state.scheduling.settings = data;
  } else if (payload.action == "updateSettings") {
    for (var key in data) {
      state.scheduling.settings[key] = data[key];
    }
  }
};

const schedulingAvailability = (state, payload) => {
  var data = payload.data;
  if (payload.action == "getAvailability") {
    state.scheduling.availability = data;
  } else if (payload.action == "addAvailability") {
    state.scheduling.availability.push(data);
  } else if (payload.action == "updateAvailability") {
    let id = payload.id;

    // For set default
    if (data.is_default) {
      for (let i = 0; i < state.scheduling.availability.length; i++) {
        let a = state.scheduling.availability[i];
        if (a.id == id) a.is_default = 1;
        else a.is_default = 0;
      }
    } else {
      // For other situations
      let item = state.scheduling.availability.find((i) => i.id == id);
      if (item) {
        for (var key in data) {
          item[key] = data[key];
        }
      }
    }
  } else if (payload.action == "deleteAvailability") {
    let id = payload.id;
    state.scheduling.availability = state.scheduling.availability.filter((a) => a.id != id);
  }
};

const schedulingEvents = (state, payload) => {
  var data = payload.data;
  if (payload.action == "getEvents") {
    state.scheduling.events = data;
  } else if (payload.action == "addEvent") {
    state.scheduling.events.unshift(data);
  } else if (payload.action == "updateEvent") {
    let id = data.id;

    for (let i = 0; i < state.scheduling.events.length; i++) {
      if (state.scheduling.events[i].id == id) {
        state.scheduling.events[i] = data;
        break;
      }
    }
  } else if (payload.action == "updateTheEvent") {
    let id = data.id;

    for (let i = 0; i < state.scheduling.events.length; i++) {
      if (state.scheduling.events[i].id == id) {
        for (var key in data) {
          state.scheduling.events[i][key] = data[key];
        }
        break;
      }
    }
  } else if (payload.action == "deleteEvent") {
    let id = data.id;
    state.scheduling.events = state.scheduling.events.filter((e) => e.id != id);
  }
  // Pendings
  else if (payload.action == "getPendings") {
    let now = moment();
    // Check expired
    let list = [];
    data.forEach((d) => {
      let slots = JSON.parse(d.slots);
      slots = slots.sort((a, b) => a.localeCompare(b));
      let is_expired = false;

      if (slots.length > 0) {
        let last_slot = slots[slots.length - 1];
        let last_slot_moment = moment(last_slot, "YYYY/MM/DD HH:mm");
        if (last_slot_moment < now) {
          is_expired = true;
        }
      } else {
        is_expired = true;
      }

      if (!is_expired) list.push(d);
    });

    state.scheduling.pendings = list;
  } else if (payload.action == "deletePending") {
    let id = data.id;
    state.scheduling.pendings = state.scheduling.pendings.filter((e) => e.id != id);
  } else if (payload.action == "addPending") {
    state.scheduling.pendings.unshift(data);
  } else if (payload.action == "updatePending") {
    let pending = state.scheduling.pendings.find((i) => i.id == data.id);
    if (pending) {
      for (var key in data) {
        pending[key] = data[key];
      }
    }
  }
  // Polls
  else if (payload.action == "getPolls") {
    let now = moment();
    // Check expired
    let list = [];
    data.forEach((d) => {
      let slots = JSON.parse(d.slots);
      slots = slots.sort((a, b) => a.localeCompare(b));
      let is_expired = false;

      if (slots.length > 0) {
        let last_slot = slots[slots.length - 1];
        let last_slot_moment = moment.tz(last_slot, "X", d.timezone);
        if (last_slot_moment < now) {
          is_expired = true;
        }
      } else {
        is_expired = true;
      }

      if (!is_expired) list.push(d);
    });

    state.scheduling.polls = list;
  } else if (payload.action == "deletePoll") {
    let id = data.id;
    state.scheduling.polls = state.scheduling.polls.filter((e) => e.id != id);
  } else if (payload.action == "addPoll") {
    state.scheduling.polls.unshift(data);
  } else if (payload.action == "updatePoll") {
    let poll = state.scheduling.polls.find((i) => i.id == data.id);
    if (poll) {
      for (var key in data) {
        poll[key] = data[key];
      }
    }
  }
  // Embeds
  else if (payload.action == "getEmbeds") {
    state.scheduling.embeds = data;
  } else if (payload.action == "deleteEmbed") {
    let id = data.id;
    state.scheduling.embeds = state.scheduling.embeds.filter((e) => e.id != id);
  } else if (payload.action == "addEmbed") {
    state.scheduling.embeds.unshift(data);
  } else if (payload.action == "updateEmbed") {
    let embed = state.scheduling.embeds.find((i) => i.id == data.id);
    if (embed) {
      for (var key in data) {
        embed[key] = data[key];
      }
    }
  }
};

const integrations = (state, payload) => {
  var data = payload.data;
  if (payload.action == "loadIntegrations") {
    state.integrations = data;
  }
};

const invitations = (state, payload) => {
  var data = payload.data;
  if (payload.action == "loadInvitations") {
    state.invitations = data;
  } else if (payload.action == "addInvitations") {
    state.invitations = [...data, ...state.invitations];
  } else if (payload.action == "deleteInvitation") {
    state.invitations = state.invitations.filter((i) => i.id != data.id);
  }
};

const organization = (state, payload) => {
  var data = payload.data;
  if (payload.action == "getOrganization") {
    state.organization = data;
  }
};

const requests = (state, payload) => {
  var data = payload.data;
  if (payload.action == "getRequests") {
    state.requests = data;
  }
};

export default {
  logout,
  setUserID,
  getMeInfo,
  updateMeInfo,
  schedulingSettings,
  schedulingAvailability,
  schedulingEvents,
  integrations,
  invitations,
  organization,
  requests,
};
